import { createSelector } from 'reselect';

const selector = (state) => state.toJS().factoryReducer;

/**
 * Retrieves factory state from factories reducer
 */
export const factorySelector = createSelector(
  selector,
  (factory) => factory.factory.data,
);

/**
 * Retrieves factory state from factories reducer
 */
export const factoryLoadingSelector = createSelector(
  selector,
  (factory) => factory.factory.loading,
);

/**
 * Retrieves factories state from factories reducer
 */
export const factoriesSelector = createSelector(
  selector,
  (factory) => factory.factories.data,
);

/**
 * Retrieves factories state from factories reducer
 */
export const factoriesLoadingSelector = createSelector(
  selector,
  (factory) => factory.factories.loading,
);

/**
 * Retrieves factories count state from factories reducer
 */
export const factoriesCountSelector = createSelector(
  selector,
  (factory) => factory.factories.count,
);

/**
 * Retrieves factories count state from factories reducer
 */
export const factoryUploadProgress = createSelector(
  selector,
  (factory) => factory.uploadFilesProgress,
);

export default factorySelector;
